module.exports = __webpack_public_path__ + "img/Logo_white.339b2f4a.svg";